import { Component, TemplateFunction } from '@ribajs/core'
import { EventDispatcher } from '@ribajs/events'

/**
 * Ported from original theme code to Riba
 */
export class HeaderMenu extends Component {
  public static tagName = 'header-menu'

  /** Listen for client side routing events */
  protected routerEvents = new EventDispatcher('main')

  mainDetailsToggle?: HTMLDetailsElement
  content?: HTMLElement

  header?: HTMLElement
  categoryMenu?: HTMLDetailsElement

  onFocusOut = this._onFocusOut.bind(this)
  onToggle = this._onToggle.bind(this)
  onKeyup = this._onKeyup.bind(this)

  scope = {}

  static get observedAttributes(): string[] {
    return []
  }

  async afterBind() {
    await super.afterBind()
    this.classList.add(`${HeaderMenu.tagName}-ready`)
  }

  constructor() {
    super()
    this.mainDetailsToggle = this.querySelector('details') || undefined
    this.content =
      (this.mainDetailsToggle?.querySelector('summary')
        ?.nextElementSibling as HTMLElement | null) || undefined
    this.header = document.querySelector('header') || undefined
    this.categoryMenu =
      document.querySelector('#Details-HeaderMenu-Categories') || undefined
  }

  connectedCallback() {
    super.connectedCallback()
    this.init(HeaderMenu.observedAttributes)
    this.addEventListeners()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListeners()
  }

  addEventListeners() {
    this.mainDetailsToggle?.addEventListener('focusout', this.onFocusOut)
    this.mainDetailsToggle?.addEventListener('toggle', this.onToggle)
    this.addEventListener('keydown', this.onKeyup, { passive: true })
    this.routerEvents.on('newPageReady', this.onNewPageReady, this)
  }

  removeEventListeners() {
    this.mainDetailsToggle?.removeEventListener('focusout', this.onFocusOut)
    this.mainDetailsToggle?.removeEventListener('toggle', this.onToggle)
    this.removeEventListener('keydown', this.onKeyup)
    this.routerEvents.off('newPageReady', this.onNewPageReady, this)
  }

  protected onNewPageReady() {
    this.close()
  }

  isOpen() {
    return this.categoryMenu?.hasAttribute('open') || false
  }

  private _onKeyup(event: KeyboardEvent) {
    switch (event.code) {
      case 'Escape':
        this.close()
        break
    }
  }

  private _onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  private _onToggle() {
    if (!this.header) return

    if (this.isOpen()) {
      this.disablePageScroll()
    } else {
      this.enablePageScroll()
    }
  }

  protected disablePageScroll() {
    document.body.style.overflowY = 'hidden'
  }

  protected enablePageScroll() {
    document.body.style.overflowY = ''
  }

  close() {
    this.mainDetailsToggle?.removeAttribute('open')
    this.mainDetailsToggle
      ?.querySelector('summary')
      ?.setAttribute('aria-expanded', 'false')
  }

  /**
   * Returns the template, if null is returned, the child html of this element / component is not replaced
   */
  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
